import { IconProps } from "../../../types/style";

const StarMedal = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M9.5 5C9.5 5.725 9.285 6.39001 8.915 6.94501C8.375 7.74501 7.52 8.31 6.525 8.455C6.355 8.485 6.18 8.5 6 8.5C5.82 8.5 5.645 8.485 5.475 8.455C4.48 8.31 3.625 7.74501 3.085 6.94501C2.715 6.39001 2.5 5.725 2.5 5C2.5 3.065 4.065 1.5 6 1.5C7.935 1.5 9.5 3.065 9.5 5Z"
          fill={color}
        />
        <path
          d="M10.625 9.7352L9.80004 9.93019C9.61504 9.97519 9.47004 10.1152 9.43004 10.3002L9.25504 11.0352C9.16004 11.4352 8.65004 11.5552 8.38504 11.2402L6.00004 8.5002L3.61504 11.2452C3.35004 11.5602 2.84004 11.4402 2.74504 11.0402L2.57004 10.3052C2.52504 10.1202 2.38004 9.9752 2.20004 9.9352L1.37504 9.7402C0.995039 9.6502 0.860039 9.17519 1.13504 8.90019L3.08504 6.9502C3.62504 7.7502 4.48004 8.31521 5.47504 8.46021C5.64504 8.49021 5.82004 8.5052 6.00004 8.5052C6.18004 8.5052 6.35504 8.49021 6.52504 8.46021C7.52004 8.31521 8.37504 7.7502 8.91504 6.9502L10.865 8.90019C11.14 9.17019 11.005 9.6452 10.625 9.7352Z"
          fill={color}
        />
        <path
          d="M6.28999 3.49L6.58499 4.08C6.62499 4.16 6.72999 4.24 6.82499 4.255L7.35999 4.345C7.69999 4.4 7.77999 4.65 7.53499 4.895L7.11999 5.30999C7.04999 5.37999 7.00999 5.515 7.03499 5.615L7.15499 6.13C7.24999 6.535 7.03499 6.69499 6.67499 6.47999L6.17499 6.18499C6.08499 6.12999 5.93499 6.12999 5.84499 6.18499L5.34499 6.47999C4.98499 6.68999 4.76999 6.535 4.86499 6.13L4.98499 5.615C5.00499 5.52 4.96999 5.37999 4.89999 5.30999L4.48499 4.895C4.23999 4.65 4.31999 4.405 4.65999 4.345L5.19499 4.255C5.28499 4.24 5.38999 4.16 5.42999 4.08L5.72499 3.49C5.86999 3.17 6.12999 3.17 6.28999 3.49Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default StarMedal;
